// The projects page portals its search toolbar into the center of the app header.
export const HEADER_CENTER_SLOT_ID = "header-center-slot";
